import { Flame, Library, Rocket, Sparkle } from "lucide-react"

// Launch/featured badges, drawn in Planami's own style so they sit quietly in the footer.
const badges = [
  {
    href: "https://startupfa.me/s/planami?utm_source=planami.app",
    label: "Featured on",
    name: "Startup Fame",
    Icon: Flame,
  },
  {
    href: "https://peerpush.com/p/planami",
    label: "Launched on",
    name: "PeerPush",
    Icon: Rocket,
  },
  {
    href: "https://www.tinystartups.com/startup/planami",
    label: "Launch planned on",
    name: "Tiny Startups",
    Icon: Sparkle,
  },
  {
    href: "https://www.tinyshelf.co/?ref=planami.app",
    label: "Featured on",
    name: "TinyShelf",
    Icon: Library,
  },
]

export function LaunchBadges() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-2 opacity-70 hover:opacity-100 transition-opacity">
      {badges.map(({ href, label, name, Icon }) => (
        <a
          key={name}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Planami — ${label} ${name}`}
          className="inline-flex h-8 items-center gap-2 rounded-md border bg-card px-2.5 text-foreground transition-colors hover:border-primary/40"
        >
          <Icon className="h-3.5 w-3.5 text-primary" aria-hidden="true" />
          <span className="flex flex-col leading-none">
            <span className="text-[8px] font-medium uppercase tracking-wider text-muted-foreground">
              {label}
            </span>
            <span className="mt-0.5 text-xs font-semibold">{name}</span>
          </span>
        </a>
      ))}
    </div>
  )
}
